import {IPageComponentProps} from "@components/default/Interfaces/IPageComponentProps.ts";
import {Box, Title} from "@mantine/core";
import * as React from "react";
import {ReactNode} from "react";
import {IPaginationResponse} from "@sitemap/apiendponts.ts";
import {PaginationComponent} from "@components/default/PaginationComponent.tsx";

interface ContainerComponentProps extends IPageComponentProps {
	children: ReactNode;
	titleAlign?: "left" | "center" | "right";
	titleVariant?: string;
	title?: string | React.ReactNode;
	slotProps?: {
		baseGrid?: any;
		titleTypography?: any;
	};
	pagination?: IPaginationResponse;
	setPagination?: React.Dispatch<React.SetStateAction<IPaginationResponse>>;
}

export function ContainerComponent(props: ContainerComponentProps) {
	return (
		<Box w="100%" mb="md" style={{opacity: 0.98}}>
			{props.title != null && !props.hideHeader && (
				<Box mb="sm" style={{textAlign: props.titleAlign ?? "center"}}>
					{typeof props.title === "string" ? (
						<Title order={3} fw={700}>
							{props.title}
						</Title>
					) : (
						props.title
					)}
				</Box>
			)}
			{props.pagination != null && (
				<Box w="100%" mb="xs">
					<PaginationComponent pagination={props.pagination} setPagination={props.setPagination} />
				</Box>
			)}
			<Box
				w="100%"
				{...props.slotProps?.baseGrid}
				style={{
					width: "100%",
					maxWidth: "100%",
					minWidth: 0,
					boxSizing: "border-box",
					...props.slotProps?.baseGrid?.style,
					...props.slotProps?.baseGrid?.sx
				}}
			>
				{props.children}
			</Box>
		</Box>
	);
}